module.exports = __webpack_public_path__ + "static/media/nbn_logo.3a7e3f11.png";